import { Component, OnInit } from '@angular/core';
import { LibraryService } from 'src/app/services/Library/library.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
    selector: 'app-publication',
    templateUrl: './publication.component.html',
    styleUrls: ['./publication.component.css']
})
export class PublicationComponent implements OnInit {
    Submitted = false;
    PublicationList: any;


    constructor(private libraryservice: LibraryService, private lookupservice: LookupService, public globalHelper: GlobalHelper,
        private spinnerService: Ng4LoadingSpinnerService) { }

    currentPage = 1;
    pageSize = 20;
    recordCount = 0;
    totalPages = 0;

    numberOfPages() {

        this.totalPages = Math.ceil(this.recordCount / this.pageSize);
    }

    nextPage() {
        this.currentPage = this.currentPage + 1;

    }

    pageSizes() {
        this.currentPage = 1;
        this.recordCount = 0;
        this.totalPages = 0;

    }

    FilterModel = {

        CurrentIndex: 0,
        PageSize: 20,
        Publication: '',
    }

    PublicationMSTModel =
        {
            PublicationID: 0,
            Publication: '',
            PublicationLocation: '',
            IsActive: true,

        }
    Clear() {
        this.PublicationMSTModel.PublicationID = 0,
        this.PublicationMSTModel.Publication = '';
        this.PublicationMSTModel.PublicationLocation = '';
        this.Submitted = false;
    }


    SavePublication(valid) {
        this.Submitted = true;
        if (valid) {
            this.spinnerService.show();
            this.libraryservice.SavePublication(JSON.stringify(this.PublicationMSTModel)).subscribe((response: any) => {
                this.spinnerService.hide();
                this.Clear();
                this.globalHelper.CheckActionStatus(response);
                this.GetAllPublication();

            })
        }
       
    }

    PublicationMarkActive(Item) {

        this.PublicationMSTModel.PublicationID = Item.PublicationID;
        this.PublicationMSTModel.IsActive = Item.IsActive == true ? false : true;
        this.spinnerService.show();
        this.libraryservice.PublicationMarkActive(JSON.stringify(this.PublicationMSTModel)).subscribe((response: any) => {
            this.spinnerService.hide
            this.globalHelper.CheckActionStatus(response);
            this.GetAllPublication();

        })

    }

    GetAllPublication() {

        this.FilterModel.CurrentIndex = this.currentPage;
        this.FilterModel.PageSize = this.pageSize;
        this.spinnerService.show();
        this.libraryservice.GetAllPublication(JSON.stringify(this.FilterModel)).subscribe((response: any) => {
            this.PublicationList = response.PublicationList;
            this.globalHelper.CheckActionStatus(response);
            this.spinnerService.hide();
            if (this.PublicationList != null && response.PublicationList.length > 0) {
                this.recordCount = this.PublicationList[0].RecordCount;

            }


        });
    }




    Edit(obj) {

        this.PublicationMSTModel.PublicationID = obj.PublicationID;
        this.PublicationMSTModel.Publication = obj.Publication;
        this.PublicationMSTModel.PublicationLocation = obj.PublicationLocation;
    }

    ngOnInit() {
        this.GetAllPublication();
    }

}
